module.exports = __webpack_public_path__ + "img/banner-1.2a445b3a.png";